import { render, staticRenderFns } from "./AthleteRyzerReport.vue?vue&type=template&id=e5c84ff6&scoped=true&"
import script from "./AthleteRyzerReport.vue?vue&type=script&lang=ts&"
export * from "./AthleteRyzerReport.vue?vue&type=script&lang=ts&"
import style0 from "./AthleteRyzerReport.vue?vue&type=style&index=0&id=e5c84ff6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5c84ff6",
  null
  
)

export default component.exports